import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";
import { useNavigate } from "react-router-dom";

export default function EventsList() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/timeline");
        setEvents(data?.events || data || []);
      } finally { setLoading(false); }
    })();
  }, []);

  if (loading) return <div className="space-y-3"><Skeleton className="h-8 w-40" /><Skeleton className="h-24 w-full" /></div>;

  return (
    <div className="space-y-6" data-testid="events-page">
      <div>
        <h1 className="text-3xl md:text-4xl font-semibold tracking-tight">All events</h1>
        <p className="text-neutral-600 mt-1 text-sm">{events.length} record{events.length !== 1 ? "s" : ""} filed.</p>
      </div>
      <div className="space-y-2">
        {events.map((e) => (
          <button
            key={e.event_id || e.id}
            data-testid={`ev-${e.event_id || e.id}`}
            onClick={() => navigate(`/events/${e.event_id || e.id}`)}
            className="w-full text-left bg-white rounded-xl border border-neutral-200 p-3 hover:border-neutral-300"
          >
            <div className="font-medium">{e.title}</div>
            <div className="text-xs text-neutral-500 mt-0.5">{e.date} · {e.type}</div>
            {e.summary && <div className="text-sm text-neutral-700 mt-1 line-clamp-2">{e.summary}</div>}
          </button>
        ))}
      </div>
    </div>
  );
}
